import httpService from '@Utils/httpService';

const managementBaseUrl = 'api/Management/PointCloudUtility';
const publicBaseUrl = 'api/PointCloudUtility';

export default {
	// ============================================
	// Management Endpoints (requires @envizion.digital email)
	// ============================================

	/**
	 * Upload a new version of the Point Cloud Utility
	 * @param {FormData} formData - Contains File, Version, ReleaseNotes, IsLatest, IsActive
	 * @param {Function} onUploadProgress - Progress callback
	 * @returns {Promise<PointCloudUtilityVersionVM>}
	 */
	upload(formData, onUploadProgress) {
		return httpService.post({
			url: `${managementBaseUrl}/upload`,
			data: formData,
			headers: { 'Content-Type': 'multipart/form-data' },
			onUploadProgress,
		});
	},

	/**
	 * Get all versions (active and inactive)
	 * @returns {Promise<PointCloudUtilityVersionVM[]>}
	 */
	getVersions() {
		return httpService.get({
			url: `${managementBaseUrl}/versions`,
		});
	},

	/**
	 * Toggle the active status of a version
	 * @param {string} id - Version ID
	 * @returns {Promise<PointCloudUtilityVersionVM>}
	 */
	toggleActive(id) {
		return httpService.put({
			url: `${managementBaseUrl}/${id}/toggle-active`,
		});
	},

	/**
	 * Set a version as the latest (clears isLatest on all other versions)
	 * @param {string} id - Version ID
	 * @returns {Promise<PointCloudUtilityVersionVM>}
	 */
	setLatest(id) {
		return httpService.put({
			url: `${managementBaseUrl}/${id}/set-latest`,
		});
	},

	/**
	 * Update a version's release notes
	 * @param {string} id - Version ID
	 * @param {string} releaseNotes - Updated release notes
	 * @returns {Promise<PointCloudUtilityVersionVM>}
	 */
	updateReleaseNotes(id, releaseNotes) {
		return httpService.put({
			url: `${managementBaseUrl}/${id}/release-notes`,
			data: { releaseNotes },
		});
	},

	/**
	 * Soft delete a version
	 * @param {string} id - Version ID
	 * @returns {Promise<void>}
	 */
	delete(id) {
		return httpService.delete({
			url: `${managementBaseUrl}/${id}`,
		});
	},

	// ============================================
	// Public Endpoints (any authenticated user)
	// ============================================

	/**
	 * Get the latest active version
	 * @returns {Promise<PointCloudUtilityVersionVM>}
	 */
	getLatest() {
		return httpService.get({
			url: `${publicBaseUrl}/latest`,
		});
	},

	/**
	 * Get a download URL for a specific version (SAS-signed, valid 1 hour)
	 * @param {string} id - Version ID
	 * @returns {Promise<{ downloadUrl: string }>}
	 */
	getDownloadUrl(id) {
		return httpService.get({
			url: `${publicBaseUrl}/download/${id}`,
		});
	},
};
